<template>
  <div class="archives-page">    
    <Header />
    <div class="title">
      <div>
        <span class="navTitle">Archives des expositions</span>
      </div>
    </div>
    <div class="navigation-buttons">
      <q-btn class="ma-2" color="pink-10" icon="arrow_back" @click="goToAdmin">
        Retour à l'administration
      </q-btn>
    </div>
    <hr style="margin-bottom: 15px;">
    <ArchivesList />
  </div>
</template>

<script>
import ArchivesList from "../components/ArchivesList.vue";
import Header from "../components/Header.vue";
import { useRouter } from "vue-router";

export default {
  components: {
    ArchivesList,
    Header
  },
  setup() {
    const router = useRouter();

    const goToAdmin = () => {
      router.push({ name: 'Admin' });
    };

    return {
      goToAdmin
    };
  }
};
</script>

<style scoped>
.archives-page {
  min-height: 100vh;
  background-color: #bfdfe0; 
}

.title {
  padding: 20px;
  background-color: #a2c4c9;
}

.navTitle {
  font-size: 24px;
  color: black;
  font-weight: bold;
}

.navigation-buttons {
  padding: 15px;
}

hr {
  border-color: #cbe0cb; /* Gris verdâtre pour la ligne de séparation */
}

h1 {
  margin-left: 5%;
  margin-bottom: 30px; 
  margin-top: 30px;
}
</style>
